module.exports = __webpack_public_path__ + "img/logo-rc.0935665f.png";